import React from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Price from './Price';
import Availability from './Availability';
import Loading from '../Loading'
import Notifications from '../../services/Notifications';
import Authorize from '../Authorize';
import MessageWarning from '../MessageWarning';
import Api from '../../services/Api';
import * as cartActions from '../../actions/cartActions';
import SummaryAvailability from './SummaryAvailability';
import * as Roles from '../../resources/UserRole';
import PricingHelper from "../../helpers/PricingHelper";
import Localization from '../../services/Localization';
import UserHelper from '../../helpers/UserHelper';
import CustomerService from '../../services/Customer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { withPIMProductConfig } from '../../hooks/PIMProductConfigContext';
import { withProductConfig } from '../../hooks/ProductConfigContext';
import { withStorefrontConfig } from '../../hooks/StorefrontSettingsContext';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer'
import Button from '@mui/material/Button';
import RelatedProducts from './RelatedProduct';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import PrintSpecsModal from './PrintSpecsModal';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
import UserService from '../../services/UserService';
import Tooltip from '@mui/material/Tooltip';
import { EstimatedDate } from './EstimatedDate';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </Box>
    );
}

export class Product extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            product: null,
            price: null,
            availability: null,
            quantityAvailable: null,
            fetchingProduct: false,
            fetchingPrice: false,
            quantity: 1,
            updateButtonIsVisible: false,
            isConfiguredProduct: true,
            isObsoleteProduct: true,
            branchStockingType: null,
            productRating: null,
            productInstallation: null,
            productMiscellaneous: null,
            productMaterial: null,
            tabValue: 0,
            indexState: [],
            repairParts: [],
            crossSellParts: [],
            replacementParts: [],
            similarParts: [],
            upsellParts: [],
            drawerOpen: false,
            drawerTitle: '',
            drawerProducts: [],
            specDrawerOpen: false,
            showPrintModal: false,
            curveNumberURL: null,
            favoriteFlag: false
        }
    }

    theme() { useTheme(); }

    componentDidMount() {
        this.mounted = true;        
        this.loadProduct(this.props.product);
        this.callApiWithCustomer();
        this.fetchAdvancedProductDetails();
        this.fetchUserFavProductDetails();
        document.addEventListener("click", this.handleQtyBlur, false);
    }

    componentWillUnmount() {
        this.mounted = false;
        document.removeEventListener("click", this.handleQtyBlur, false);
    }

    componentDidUpdate(prevProps) {
        if (this.props !== prevProps) {
            this.callApiWithCustomer();
        }
    }

    setMountedState = (state, callback) => {
        if (this.mounted)
            this.setState(state, () => callback && callback());
    }

    setSku = (props, callback) => {
        if (props.product)
            this.setMountedState({ sku: props.sku }, () => { callback && callback() });
    }

    openDrawer = (title, products) => () => {
        this.setState({
            drawerOpen: true,
            drawerTitle: title,
            drawerProducts: products
        });
    };
    closeDrawer = () => {
        this.setState({ drawerOpen: false });
    };
    renderRelatedSection(title, products) {
        if (products.length === 0) return null;

        const { cartActions, selectedCustomer, cartLines } = this.props;
        const { drawerOpen } = this.state;

        return (
            <div>
                <AppBar position="static" color="default" elevation={1}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={this.openDrawer(title, products)}
                            aria-label="Toggle Related Products Drawer"
                            sx={{
                                mr: 2,
                                padding: 1.5,
                                borderRadius: 2,
                                '&:hover': {
                                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                },
                                '&:focus': {
                                    outline: '2px solid #1976d2',
                                },
                            }}
                        >
                            {drawerOpen ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                        </IconButton>

                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                            {title}
                        </Typography>
                    </Toolbar>
                </AppBar>

                <Drawer
                    anchor="bottom"
                    open={drawerOpen}
                    onClose={this.toggleDrawer()}
                    PaperProps={{
                        style: {
                            height: 'auto',
                            maxHeight: '86vh',
                            minHeight: '300px'
                        }
                    }}
                >
                    <div style={{
                        width: '100%',
                        padding: 16,
                        boxSizing: 'border-box',
                        overflowY: 'auto',
                        overflowX: 'hidden'
                    }}>
                        <RelatedProducts
                            products={products}
                            cartActions={cartActions}
                            localized={this.props.productConfig.labels}
                            selectedCustomer={selectedCustomer}
                            cartLines={cartLines}
                            maxLines={100}
                            associationType={title}
                        />
                    </div>
                </Drawer>
            </div>
        );
    }


    callApiWithCustomer = () => {
        if (this.props.fetchPriceOnLoad) {
            Api.fetch(url(this.props.selectedCustomer.id, this.props.selectedCustomer.companyCode, this.props.product.sku, this.props.currentUser.storefrontId, this.props.selectedCustomer.brandCode, this.props?.StorefrontConfig?.locale, this.props?.productConfig?.settings?.UseBranchStockingType)).then(this.loadProduct);
        }
    }


    toggleDrawer = () => () => {
        this.setState({ drawerOpen: !this.state.drawerOpen });
    };

    toggleSpecDrawer = () => () => {
        this.setState({ specDrawerOpen: !this.state.specDrawerOpen });
    };


    handleChange = (e) => {
        this.setMountedState({ [e.target.name]: e.target.value });
    }

    handleQtyBlur = (e) => {
        if (this.nodeQuantity && this.nodeQuantity.contains(e.target))
            return;
        if (this.state.quantity === "")
            this.setMountedState({ quantity: 1 });
        this.setMountedState({ quantity: this.state.quantity, updateButtonIsVisible: false });
    }

    handleQtyOnFocus = (e) => {
        this.setMountedState({ updateButtonIsVisible: true });
    }

    handleQtyChange = (e) => {
        this.setMountedState({ updateButtonIsVisible: true });
        if (e.target.value === "") {
            this.setMountedState({ quantity: e.target.value });
        }
        else if (isPositiveNumber(e.target.value)) {
            this.setMountedState({ quantity: parseInt(e.target.value) });
        }
    }

    handleQtyKeyUp = (e) => {
        if (e.keyCode === 13)
            this.handleQtyUpdateClick();
    }

    handleQtyUpdateClick = () => {
        this.setMountedState({ updateButtonIsVisible: false });
        this.fetchPricing();
    }

    fetchPricing = () => {
        if (this.props.selectedCustomer && this.props.selectedCustomer.billingType !== "1" && this.props.fetchPriceOnLoad && !this.state.isConfiguredProduct && !this.state.isObsoleteProduct) {
            this.setMountedState({ fetchingPrice: true }, () => {
                const priceAvailRequest = this.getPriceAvailabilityRequest();
                Api.fetch(`/api/products/GetPriceAndAvailability`, { method: 'POST', body: JSON.stringify(priceAvailRequest) }, false).then(this.handleResponse).then(this.loadPricing)
            });
        }
        else {
            this.setMountedState({ fetchingPrice: false });
        }
    }

    fetchAdvancedProductDetails = () => {
        return Api.fetch(`/api/products/GetAdvancedProductDetails/` + encodeURIComponent(this.props.product.sku), { method: 'POST' }).then(this.handleResponse).then(this.loadAdvancedProductDetails)
    }
    fetchUserFavProductDetails = async () => {
        return await Api.fetch('/api/user/GetFavoritesListByUser').then(this.showFavoriteUser);
    }

    handleResponse(res) {
        if (res)
            return res.json();
    }

    handleTabChange = (event, newValue) => {
        this.setMountedState({ tabValue: newValue });
    };

    handleChangeIndex = (index) => {
        setValue(index);
    };

    a11yProps(index) {
        return {
            id: `full-width-tab-${index}`,
            'aria-controls': `full-width-tabpanel-${index}`,
        };
    }

    handleOpenPrintModal = () => {
        this.setState({ showPrintModal: true });
    };

    handleClosePrintModal = () => {
        this.setState({ showPrintModal: false });
    };


    getPriceAvailabilityRequest = () => {
        return {
            customerId: this.props.selectedCustomer.externalId,
            storefront: this.props.currentUser.storefrontNumber,
            storefrontId: this.props.StorefrontConfig.storefront.id,
            company: this.props.selectedCustomer.companyCode,
            sku: this.props.product.sku,
            transactionQuantity: this.state.quantity?.toString() || "1",
            implementationId: this.props.StorefrontConfig.storefront.implementationId,
            useBranchStockingType: this.props.productConfig.settings.UseBranchStockingType,
            isSeparatePriceAvailability: this.props.productConfig.settings.IsSeparatePriceAvailability
        };
    }

    handleAddToCart = () => {
        if (this.state.fetchingPrice === false)
            return this.addToCart();

        Notifications.error(this.props.productConfig.labels.FetchingPriceMessage);

    }

    addToCart = () => {
        const localized = this.props.productConfig.labels;
        const isUseUp = (this.props.productConfig.settings.UseBranchStockingType && this.state.branchStockingType === "U" && this.state.availability === "Backordered")
            || (!this.props.productConfig.settings.UseBranchStockingType && this.state.product.stockingType === "U" && this.state.availability === "Backordered");
        let product = { product: this.state.product, quantity: this.state.quantity, netPrice: this.state.price };
        if (this.state.availability === null || this.state.availability === "Unavailable" || this.state.availability === "Unknown" || (isUseUp && this.state.quantityAvailable < 1)) {
            return Notifications.error(localized.UnavailableMessage);
        }
        else if (this.props.productConfig.settings.IsSeparatePriceAvailability == true || this.state.price.amount == 0) {
            return Notifications.error(localized.PriceNotReady);
        }

        this.props.cartActions.AddItemToCart(product, localized);

    }

    loadProduct = (data) => {
        const associatedProducts = data.associatedProducts.filter(x => x.imageUrl != null && x.imageUrl != '')
        data.associatedProducts = associatedProducts;
        this.setMountedState({
            product: data,
            fetchingProduct: false,
            sku: data.sku,
            isConfiguredProduct: PricingHelper.isItemConfigured(data),
            isObsoleteProduct: PricingHelper.isItemObsolete(data),
        });

        this.checkPriceAvailability = UserHelper.checkPriceAvailability(this.props.selectedCustomer, this.props.currentUser.storefrontNumber);
        this.fetchPricing();
    }

    loadPricing = (data) => {
        if (data) {
            this.setMountedState({
                price: data && this.props.currentUser.roles.includes(Roles.VIEW_NET_PRICE) ? { amount: data.price, currency: data.currency } : this.state.product.listPrice,
                fetchingPrice: false,
                availability: data.availability,
                quantityAvailable: data.quantityAvailable,
                branchStockingType: data.branchStockingType
            });
        }
    }

    loadAdvancedProductDetails = (data) => {
        if (data) {
            this.setMountedState({
                productRating: data.hasProductRating ? data.productRating : null,
                productInstallation: data.hasProductInstallation ? data.productInstallation : null,
                productMiscellaneous: data.hasProductMiscellaneous ? data.productMiscellaneous : null,
                productMaterial: data.hasProductMaterial ? data.productMaterial : null,
            })
            let intermediateState = [];
            intermediateState.push(this.state.productRating);
            intermediateState.push(this.state.productMaterial);
            intermediateState.push(this.state.productInstallation);
            intermediateState.push(this.state.productMiscellaneous);
            this.setMountedState({ indexState: intermediateState.filter(x => x != null) });
            if (data.curveNumberURL != null && data.curveNumberURL != "" && data.curveNumberURL != undefined) {
                this.setMountedState({ curveNumberURL: data.curveNumberURL });
            }

        }
    }

    showAvailabilityByLocation = () => {
        return (this.props.selectedCustomer
            && !this.state.updateButtonIsVisible
            && this.props.productConfig.settings.AvailabilityByLocation === true);
    }

    checkCreditHold = () => {
        if (this.props.selectedCustomer && this.props.currentUser.storefront === '6400')
            return CustomerService.checkCreditHold(this.props.selectedCustomer);
        else
            return false;
    }

    productAvailability = (stockingType, availability) => {
        // For use up items return unavailable.
        if (stockingType === "U" && availability === "Backordered")
            return this.props.productConfig.labels.Unavailable;
        // This check for Australia showing available for manufacturing items for now. This might be removed in future
        if (this.state.branchStockingType === "M" && availability != null && this.props.productConfig.settings.ShowAvailable === true)
            return this.props.productConfig.labels.Available;

        return availability;
    }
    handleAddToFavorite = async (mode) => {
        const localized = this.props.productConfig.labels;
        if (mode) {
            const addFavResponse = await UserService.addUserFavorite(this.props.currentUser.id, this.props.product.id);
            if (addFavResponse) {
                this.setState({ favoriteFlag: addFavResponse });
                Notifications.message(localized.CreateFavorite);
            } else {
                Notifications.message(localized.FavoriteError);
            }

        } else {
            const removedFavResponse = await UserService.removeUserFavorite(this.props.product.id);
            if (removedFavResponse) {
                this.setState({ favoriteFlag: false });
                Notifications.message(localized.DeleteFavorite);
            }
            else { Notifications.message(localized.FavoriteError); }
        }
    }
    showFavoriteUser = (data) => {
        const isFavorite = data?.some(x => x.productId === this.props.product.id) ?? false;
        this.setState({ favoriteFlag: isFavorite });
    }

    render() {
        const { PIMProductConfig } = this.props;
        const PIMlocalized = PIMProductConfig?.labels;
        const localized = this.props.productConfig?.labels;
        const { RelatedItemsX_SELL, RelatedItemsSimilar, RelatedItemsrepair_pack, RelatedItemsReplacement, RelatedItemsUPSELL } = localized;
        const associatedProducts = this.state.product?.associatedProducts || [];
        const isUseUp = (this.props.productConfig.settings.UseBranchStockingType && this.state.branchStockingType === "U" && this.state.availability !== "Unavailable")
            || (!this.props.productConfig.settings.UseBranchStockingType && this.state.product?.stockingType === "U" && this.state.availability !=="Unavailable");

        this.state.repairParts = associatedProducts.filter(x => x.associationType === RelatedItemsrepair_pack);
        this.state.crossSellParts = associatedProducts.filter(x => x.associationType === RelatedItemsX_SELL);
        this.state.replacementParts = associatedProducts.filter(x => x.associationType === RelatedItemsReplacement);
        this.state.similarParts = associatedProducts.filter(x => x.associationType === RelatedItemsSimilar);
        this.state.upsellParts = associatedProducts.filter(x => x.associationType === RelatedItemsUPSELL);

        let creditHold = this.checkCreditHold();
        const maxLines = 100;
        const customerWarningMessage = (this.props.selectedCustomer.isActive === false) ? localized.InActiveCustomerSelectedWarningMessage : localized.ShipToNotSelectedWarningMessage;

        const sections = [
            this.state.productRating,
            this.state.productInstallation,
            this.state.productMiscellaneous,
            this.state.productMaterial
        ];

        const isConfiguredItem = this.state.product && this.state.product.stockingType && this.state.product.stockingType.toUpperCase().trim() === 'C';

        const hasAnyValues =
            sections.some(section => section && Object.getOwnPropertyNames(section).length > 0) ||
            this.state.curveNumberURL;

        return (
            <Box className="fele-product-details">
                {
                    this.state.fetchingProduct &&
                    <Loading type="brand" />
                }
                {
                    creditHold &&
                    <Box id="CreditHoldWarning">
                        <MessageWarning title={""} message={localized.CreditHold_Warning} />
                    </Box>
                }
                {
                    this.props.selectedCustomer &&
                    !this.checkPriceAvailability &&
                    !this.props.multisearch &&
                    <Box id="CustomerIsBillToWarning">
                        <MessageWarning title={localized.ShipToNotSelectedWarningTitle} message={customerWarningMessage} />
                    </Box>
                }
                {
                    !this.state.fetchingProduct && this.state.product &&
                    <Box className="grid">
                        <Box className="container mb-5">
                            <Box className="row">
                                <Box className="col-md-12 col-xl-7">
                                    <Box className="row">
                                        {
                                            this.state.product.imageUrl &&
                                            <Box className="order-2 order-xl-1 col-md-12 col-xl-5 pt-0 pt-md-3 pt-xl-5">
                                                <img alt={this.state.product.sku} className="img-fluid" src={`${this.state.product.imageUrl}600x450px@1x/${this.state.product.sku}.jpg?q=80&x.template=y&crop=false`} />
                                                <Box className="image-disclaimer">{localized.ImageDisclaimer}</Box>
                                            </Box>
                                        }
                                        <Box className={this.state.product.imageUrl ? "order-1 order-xl-2 col-md-12 col-xl-7 pt-5" : "col-md-12 pt-5"}>
                                            <Box className="part-name">
                                                <Box className="content"
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        p: -1,
                                                    }}
                                                >
                                                    {this.state.product.description}
                                                    <Tooltip title={this.state.favoriteFlag ? <h1 style={{ fontSize: "15px" }}>{localized.RemoveFavorites}</h1>
                                                        : <h1 style={{ fontSize: "15px" }}>{localized.AddFavorites}</h1>} placement="top">
                                                        <Button onClick={() => this.handleAddToFavorite(!this.state.favoriteFlag)}>
                                                            {this.state.favoriteFlag ? <FavoriteRoundedIcon sx={{ fontSize: 25, color: 'red' }} color="secondary" />
                                                                : <FavoriteBorderRoundedIcon sx={{ fontSize: 25, color: 'black' }} color="secondary" />}
                                                        </Button>
                                                    </Tooltip>
                                                </Box>
                                            </Box>
                                            {
                                                this.state.product.name &&
                                                <Box className="model-number pb-3">
                                                    <Box className="label">{localized.ModelNumber_Label}</Box>
                                                    <Box className="content">
                                                        {this.state.product.name}
                                                    </Box>
                                                </Box>
                                            }
                                            <Box className="sku">
                                                <Box className="label">{localized.Item_Label}</Box>
                                                {this.props.showLink && <Box className="content"><Link to={{ pathname: `/product/${encodeURIComponent(this.state.product.sku)}`, state: { selectedCustomer: this.props.selectedCustomer } }}>{this.state.product.sku}</Link></Box>}
                                                {!this.props.showLink && <Box className="content">{this.state.product.sku}</Box>}
                                            </Box>
                                        </Box>
                                    </Box>
                                    {this.state.product.associatedProducts.find(x => x.sku == 'dummy_sku_replacement_association_none') && <Box>
                                        <Typography variant='h5'>This Item does not have a Replacement</Typography>
                                    </Box>}
                                    <Box className="row">
                                        <Box className="col pt-5 pb-5">
                                            {
                                                this.state.product.generalDescription &&
                                                <Box className="long-description">
                                                    <Box className="content">
                                                        {this.state.product.generalDescription}
                                                    </Box>
                                                </Box>
                                            }
                                        </Box>
                                    </Box>
                                    </Box>
                                    <Box className="col-md-12 col-xl-4 bg-secondary" style={{ flex: 1 }} >
                                    {isConfiguredItem ? (
                                        <Box style={{ display: "flex", justifyContent: "center", height: "100%", width: "100%", marginTop: "1.5rem", padding: "2rem" }}>
                                            <MessageWarning title={localized.ConfiguredItemWarningTitle} message={localized.ConfiguredItemWarning} />
                                        </Box>
                                    ) : (<>
                                        <Box className="row">
                                            <Box className="order-3 col-md-12 pt-5">
                                                <Box className="row">
                                                    <Box className="col-4">
                                                        {
                                                            this.state.product.listPrice && this.props.productConfig.settings.HideListPrice &&
                                                            <Box className="list-price">
                                                                <Box className="label">{localized.ListPriceLabel}</Box>
                                                                <Box className="content"> <Price price={this.state.product.listPrice} country={this.props.selectedCustomer.address.country} /></Box>
                                                            </Box>
                                                        }
                                                    </Box>
                                                    <Box className="col-8">
                                                        {
                                                            this.checkPriceAvailability && this.state.product.landedCostRule !== "NEW" &&
                                                            <Box className="cost">
                                                                {
                                                                    !this.state.fetchingPrice && !this.state.price && !this.state.availability &&
                                                                    <Box className="button-wrapper">
                                                                        <button className="button button-alt" onClick={this.handleQtyUpdateClick}>{localized.AvailabilityCost_ButtonText}</button>
                                                                    </Box>
                                                                }
                                                                {
                                                                    this.state.fetchingPrice && !this.props.productConfig.settings.HideYourCost === true && <Loading />}
                                                                {
                                                                    !this.state.fetchingPrice && this.state.price && this.state.availability && !this.props.productConfig.settings.HideYourCost === true &&
                                                                    <React.Fragment>
                                                                    <Box className="label">{localized.YourCostLabel}</Box>
                                                                        <Availability availability={this.productAvailability(this.props.productConfig.settings.UseBranchStockingType ? this.state.branchStockingType ?? this.state.product.stockingType : this.state.product.stockingType, this.state.availability)} asIcon={true} />
                                                                        {
                                                                            this.state.availability === "Unavailable" && <span className="price">{localized.Unavailable}</span>
                                                                        }
                                                                        <Price price={this.state.price} country={this.props.selectedCustomer.address.country} />
                                                                    </React.Fragment>
                                                                }
                                                            </Box>
                                                        }
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                        {
                                            <Box className="row">
                                                <Box className="order-3 col-md-12 pt-5">
                                                    <Box className="row">
                                                        <Box className="col-5">
                                                            {
                                                                <React.Fragment>
                                                                    {
                                                                        this.props.productConfig.settings.EstimatedShipDate === true &&
                                                                        <EstimatedDate branchStockingType={this.state.branchStockingType}
                                                                            standardShippingDays={this.props.StorefrontConfig.settingsList.StandardShippingDays}
                                                                            localized={localized}
                                                                            dateFormat={this.props.StorefrontConfig.settingsList.DateFormat} />
                                                                    }
                                                                </React.Fragment>
                                                            }
                                                        </Box>
                                                        <Box className="col-7">
                                                            {
                                                                this.checkPriceAvailability && this.state.product.landedCostRule !== "NEW" &&
                                                                <Box className="availability">
                                                                    <Box className="label">{localized.AvailabilityLabel}:</Box>
                                                                    {
                                                                        this.state.fetchingPrice &&
                                                                        <Box className="pill">
                                                                            <Loading />
                                                                        </Box>
                                                                    }
                                                                    {
                                                                                    !this.state.fetchingPrice &&
                                                                                    <Availability availability={this.productAvailability(this.props.productConfig.settings.UseBranchStockingType ? this.state.branchStockingType ?? this.state.product.stockingType : this.state.product.stockingType, this.state.availability)} />
                                                                    }
                                                                                {
                                                                                    !this.state.fetchingPrice && this.props.productConfig.settings.ShowUseUpQuantity === true && isUseUp && this.state.quantityAvailable > 0 && this.state.availability !== "Unavailable" 
                                                                                    && ((this.props.productConfig.settings.UseBranchStockingType && this.state.branchStockingType === "U") || this.state.product.stockingType === "U") &&
                                                                        <Box style={{ whiteSpace: 'nowrap', marginTop: '4px' }}>
                                                                            <FontAwesomeIcon icon={faExclamationTriangle} color="orange" /> {localized.QuantityAvailableLabel.replace("{0}", this.state.quantityAvailable)}
                                                                        </Box>
                                                                    }
                                                                    {
                                                                     this.state.product && this.state.product.stockingType && this.state.product.stockingType.toUpperCase().trim() === 'O' &&
                                                                     <MessageWarning title={localized.ObsoleteItem || 'Obsolete Item'} message={localized.ObsoleteItemsNotAvailable || 'Obsolete items are not available for purchase'} />
                                                                    }
                                                                </Box>

                                                            }
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        }

                                        {
                                            // availability by location
                                            this.checkPriceAvailability && this.state.product.landedCostRule !== "NEW" &&
                                            <>
                                                <Box className="add-to-cart" style={{ marginBottom: '3rem' }}>
                                                    <Box className="flex">
                                                        <Authorize hasRoles={[Roles.DEVELOPER, Roles.VIEW_AVAILABILITY_BY_LOCATION, Roles.VIEW_NET_PRICE, Roles.PLACE_ORDERS]} displayMessage={false}>
                                                            <Box className="input-wrapper quantity" ref={node => (this.nodeQuantity = node)}>
                                                                {
                                                                    this.props.cartLines < maxLines &&
                                                                    <input
                                                                        type="text"
                                                                        name="quantity"
                                                                        value={this.state.quantity}
                                                                        onChange={this.handleQtyChange}
                                                                        onBlur={this.handleQtyBlur}
                                                                        onFocus={this.handleQtyOnFocus}
                                                                        onKeyUp={this.handleQtyKeyUp}
                                                                        autoComplete="off" />
                                                                }
                                                                {
                                                                    this.state.updateButtonIsVisible && !this.state.fetchingPrice && this.props.cartLines < maxLines &&
                                                                    <Box className="update button-wrapper small">
                                                                        <button className="button button-alt" onClick={this.handleQtyUpdateClick} >{localized.ButtonText_CheckAvailability}</button>
                                                                    </Box>
                                                                }
                                                            </Box>
                                                        </Authorize>
                                                        <Authorize hasRoles={[Roles.PLACE_ORDERS]} displayMessage={false}>
                                                            {
                                                                this.props.cartLines < maxLines &&
                                                                <Box className="button-wrapper add-to-order">
                                                                    <button className="button" onClick={this.handleAddToCart}>{localized.ButtonText_AddToOrder}</button>
                                                                </Box>
                                                            }
                                                            {
                                                                this.props.cartLines >= maxLines &&
                                                                <Box style={{ whiteSpace: 'nowrap', fontSize: 'large', marginTop: '4px' }}>
                                                                    <FontAwesomeIcon icon={faExclamationTriangle} color="orange" /> {localized.CartMaxLines}
                                                                </Box>
                                                            }
                                                        </Authorize>
                                                    </Box>
                                                </Box>
                                                {this.showAvailabilityByLocation() && this.props.selectedCustomer.address?.country !== "US" &&
                                                    <Box className="availability-by-loc pt-5 pb-5">

                                                        <Authorize hasRoles={[Roles.VIEW_AVAILABILITY_BY_LOCATION]} displayMessage={false}>
                                                            <SummaryAvailability sku={this.state.sku} productId={this.state.product.id} userStorefront={this.props.currentUser.storefrontNumber} stockingType={this.state.product.stockingType}
                                                                quantity={this.state.quantity} customer={this.props.selectedCustomer} showAvailable={this.props.productConfig.settings.ShowAvailable} />
                                                        </Authorize>

                                                    </Box>
                                                }
                                                {this.props.productConfig.settings.ShowDisplayLeadTimesButton === true &&
                                                    <Box><hr />
                                                        <Box className="displayLeadTimes pt-3 pb-3">
                                                            <Box className="button-wrapper add-to-order">
                                                                <a href={this.props.StorefrontConfig.settingsList.DisplayLeadTimesURL} target='_blank'>
                                                                    <button className="button">{localized.DisplayLeadTimesButtonLabel}</button>
                                                                </a>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                }
                                                {this.props.productConfig.settings.ShowOKCInventoryMessage === true && this.props.selectedCustomer.address?.country === "CA" &&
                                                    <Box>
                                                        <Authorize hasRoles={[Roles.VIEW_AVAILABILITY_BY_LOCATION]} displayMessage={false}>
                                                            <hr />
                                                            <Box className="displayLeadTimes pt-3 pb-3">
                                                                <Box className="button-wrapper add-to-order">
                                                                    <span>{localized.OKCInventoryMessage}</span>
                                                                </Box>
                                                            </Box>
                                                        </Authorize>
                                                    </Box>
                                                }
                                                {this.props.StorefrontConfig.settingsList.ShowVirtualLocations == '1' &&
                                                    <Box>
                                                        <Authorize hasRoles={[Roles.VIEW_AVAILABILITY_BY_LOCATION]} displayMessage={false}>
                                                            <hr />
                                                            <Box className="displayLeadTimes pt-3 pb-3">
                                                                <Box className="add-to-order">
                                                                    <p>
                                                                        {localized.VirtualLocationsTooltip1 + " "}                                                                       
                                                                        <strong>{localized.VirtualLocations}</strong>
                                                                        {", " + localized.VirtualLocationsTooltip3}
                                                                    </p>
                                                                </Box>
                                                            </Box>
                                                        </Authorize>
                                                    </Box>
                                                }
                                                {this.props.StorefrontConfig.settingsList.ShowAvailNote2 == '1' &&
                                                    <Box>
                                                        <Authorize hasRoles={[Roles.VIEW_AVAILABILITY_BY_LOCATION]} displayMessage={false}>
                                                            <Box className="displayLeadTimes pt-3 pb-3">
                                                                <Box className="add-to-order">
                                                                    <p>
                                                                        {localized.AvailNote2}
                                                                    </p>
                                                                </Box>
                                                            </Box>
                                                        </Authorize>
                                                    </Box>
                                                }
                                            </>
                                        }
                                    </>)}
                                </Box>
                            </Box>

                            {(hasAnyValues && this.props.productConfig.settings.ShowPIMSpecifications) && (
                                <>
                                    <AppBar position="static" color="default" elevation={5} sx={{ marginTop: "5%" }}>
                                        <Toolbar>
                                            <IconButton
                                                edge="start"
                                                color="inherit"
                                                onClick={this.toggleSpecDrawer()}
                                                aria-label="Toggle Specifications Drawer"
                                                sx={{
                                                    mr: 2,
                                                    padding: 1.5,
                                                    borderRadius: 2,
                                                    '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
                                                    '&:focus': { outline: '2px solid #1976d2' },
                                                }}
                                            >
                                                {this.state.specDrawerOpen ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                                            </IconButton>
                                            <Typography variant="h6" sx={{ flexGrow: 1 }}>Specifications</Typography>
                                        </Toolbar>
                                        <PrintSpecsModal
                                            open={this.state.showPrintModal}
                                            onClose={this.handleClosePrintModal}
                                            productRating={this.state.productRating}
                                            productMaterial={this.state.productMaterial}
                                            productInstallation={this.state.productInstallation}
                                            productMiscellaneous={this.state.productMiscellaneous}
                                            product={this.state.product}
                                            handleClose={this.handleClosePrintModal}
                                            isPrintModalOpen={this.state.showPrintModal}
                                            curveNumberURL={`${this.state.curveNumberURL}.template=y&crop=false`}
                                            localized={PIMlocalized}
                                        />
                                    </AppBar>

                                    <Drawer anchor="right" open={this.state.specDrawerOpen} onClose={this.toggleSpecDrawer()}>
                                        <Box sx={{ width: 1000, padding: 2 }}>
                                            <Button variant="contained" onClick={this.handleOpenPrintModal}>
                                                Print Specifications
                                            </Button>


                                            {[
                                                this.state.productRating,
                                                this.state.productMaterial,
                                                this.state.productInstallation,
                                                this.state.productMiscellaneous
                                            ].some(Boolean) && (
                                                    <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: 2 }}>
                                                        <Tabs
                                                            sx={{ background: "#D8D8D8" }}
                                                            value={this.state.tabValue}
                                                            onChange={this.handleTabChange}
                                                            indicatorColor="primary"
                                                            aria-label="specification tabs"
                                                        >
                                                            {[
                                                                { label: PIMlocalized.ProductRating, data: this.state.productRating },
                                                                { label: PIMlocalized.ProductMaterial, data: this.state.productMaterial },
                                                                { label: PIMlocalized.ProductInstallation, data: this.state.productInstallation },
                                                                { label: PIMlocalized.ProductMiscellaneous, data: this.state.productMiscellaneous }
                                                            ].map((spec, index) =>
                                                                spec.data ? (
                                                                    <Tab key={index} sx={{ fontSize: 12 }} label={spec.label} {...this.a11yProps(index)} />
                                                                ) : null
                                                            )}
                                                        </Tabs>
                                                    </Box>
                                                )}


                                            {[
                                                this.state.productRating,
                                                this.state.productMaterial,
                                                this.state.productInstallation,
                                                this.state.productMiscellaneous
                                            ].map((specData, index) =>
                                                specData ? (
                                                    <CustomTabPanel key={index} value={this.state.tabValue} index={index}>
                                                        {Object.entries(specData)
                                                            .filter(([key, value]) => value != null && key !== 'productId' && key !== 'sku')
                                                            .map(([key, value], idx) => (
                                                                <Box
                                                                    key={idx}
                                                                    sx={{
                                                                        display: 'flex',
                                                                        justifyContent: 'space-between',
                                                                        marginBottom: '10px',
                                                                        borderBottom: 1,
                                                                        borderColor: 'divider',
                                                                    }}
                                                                >
                                                                    <Box sx={{ fontWeight: "bold" }}>{PIMlocalized[key] || key}</Box>
                                                                    <Box sx={{ textAlign: 'right' }}>{value}</Box>
                                                                </Box>
                                                            ))}
                                                    </CustomTabPanel>
                                                ) : null
                                            )}
                                        </Box>
                                        {this.state.curveNumberURL &&
                                            <Box width="50%" height="50%">
                                                <Typography variant="h4" sx={{ flexGrow: 1, padding: 2 }}>{PIMlocalized.CurveUrl1}</Typography>
                                                <Box
                                                    sx={{
                                                        border: 'none',
                                                        display: 'block',
                                                        mx: 'auto',
                                                    }}
                                                >
                                                    <img alt={PIMlocalized.CurveUrl1} className="img-fluid" src={`${this.state.curveNumberURL}.template=y&crop=false`} />
                                                </Box>
                                            </Box>
                                        }
                                    </Drawer>
                                </>
                            )}
                                {this.props.productConfig.settings.ShowRelatedItems === true &&
                                    this.state.product &&
                                    this.state.product.associatedProducts &&
                                    this.state.product.associatedProducts.length > 0 && (
                                        <Box sx={{ mt: 4 }}>
                                            {this.renderRelatedSection(localized.RelatedItemsrepair_pack, this.state.repairParts)}
                                            {this.renderRelatedSection(localized.RelatedItemsUPSELL, this.state.upsellParts)}
                                            {this.renderRelatedSection(localized.RelatedItemsReplacement, this.state.replacementParts)}
                                            {this.renderRelatedSection(localized.RelatedItemsX_SELL, this.state.crossSellParts)}
                                            {this.renderRelatedSection(localized.RelatedItemsSimilar, this.state.similarParts)}
                                        </Box>
                                    )}


                                <Drawer
                                    anchor="bottom"
                                    open={this.state.drawerOpen}
                                    onClose={this.closeDrawer}
                                    PaperProps={{
                                        style: {
                                            height: 'auto',
                                            maxHeight: '86vh',
                                            minHeight: '300px'
                                        }
                                    }}
                                >
                                    <div style={{
                                        width: '100%',
                                        padding: 16,
                                        boxSizing: 'border-box',
                                        overflowY: 'auto',
                                        overflowX: 'hidden'
                                    }}>
                                        <AppBar position="static" color="default" elevation={1}>
                                            <Toolbar>
                                                <IconButton
                                                    edge="start"
                                                    color="inherit"
                                                    onClick={this.closeDrawer}
                                                    aria-label="Close Drawer"
                                                    sx={{
                                                        mr: 2,
                                                        padding: 1.5,
                                                        borderRadius: 2,
                                                        '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
                                                        '&:focus': { outline: '2px solid #1976d2' },
                                                    }}
                                                >
                                                    <ChevronRightIcon />
                                                </IconButton>
                                                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                                                    {this.state.drawerTitle}
                                                </Typography>
                                            </Toolbar>
                                        </AppBar>
                                        <RelatedProducts
                                            products={this.state.drawerProducts}
                                            cartActions={this.props.cartActions}
                                            localized={localized}
                                            selectedCustomer={this.props.selectedCustomer}
                                            cartLines={this.props.cartLines}
                                            maxLines={100}
                                            associationType={this.state.drawerTitle}
                                        />
                                    </div>
                                </Drawer>

                        </Box>
                    </Box>
                }
            </Box>
        );
    }
};

function url(customerId, companyCode, sku, storefrontId, brandCode, locale, useBranchStockingType= false) {
    const regexForwardslash = new RegExp("/", "g");
    let trimmedSku = sku.replace(regexForwardslash, "|");
    let url = `/api/products/${trimmedSku}/${customerId}/${companyCode}/${storefrontId}`;
    if (brandCode) {
        url = `${url}/${brandCode}`;
    }
    url = `${url}/${useBranchStockingType}?locale=${locale}`;
    return url;
}

function isPositiveNumber(value) {
    let exp = new RegExp(/^[1-9]\d*$/)
    return exp.test(value);
}

Product.propTypes = {
    cartActions: PropTypes.object,
    selectedCustomer: PropTypes.object,
}

function mapStateToProps(state) {
    return {
        currentUser: state.user.currentUser,
        cartLines: state.cart.items.length,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        cartActions: bindActionCreators(cartActions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStorefrontConfig(withPIMProductConfig(withProductConfig(Product))));